import { DocumentPanel } from "@/pages/documents/components/DocumentPanel";

export function DocumentsTab({ id, name }: { id: string; name: string }) {
  return <DocumentPanel ownerType="spv_pool" ownerId={id} rootName={name} />;
}
